var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoneIcon = function SvgPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.12759 0 0 7.1276 0 16C0 24.8724 7.12697 32 16 32C24.8724 32 32 24.873 32 16C32 7.1276 24.8724 0 16 0ZM21.9636 25.0183C19.4909 25.6 17.0183 24.7273 17.0183 24.7273C14.5456 22.9819 12.9457 20.9454 12.073 19.491L11.7823 19.2002C10.9096 17.7458 9.30951 15.4184 8.58241 12.3638C8.58241 12.3638 8.8734 9.74561 10.3278 7.70919C12.0733 6.40012 12.946 7.12747 12.946 7.12747L15.2731 10.473C15.5641 10.9093 15.4185 11.491 14.9822 11.782L13.3821 12.8001C13.3821 12.8001 11.9277 13.2365 14.6912 17.4547C17.4547 21.5273 18.182 20.2182 18.182 20.2182L19.7821 19.2001C20.2185 18.9091 20.8002 19.0547 21.0912 19.4911L23.4183 22.8366C23.4181 22.6907 23.7091 23.8546 21.9636 25.0183Z",
    fill: "url(#paint0_linear_3602_14260)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3602_14260",
    x1: 0,
    y1: 16,
    x2: 32,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF9160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F649E1"
  })))));
};
export default SvgPhoneIcon;